import { render, staticRenderFns } from "./ownerDetailCoupon.vue?vue&type=template&id=c84d20a6&scoped=true"
import script from "./ownerDetailCoupon.vue?vue&type=script&lang=js"
export * from "./ownerDetailCoupon.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailCoupon.vue?vue&type=style&index=0&id=c84d20a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84d20a6",
  null
  
)

export default component.exports